import * as React from 'react';

export const LazyFinancialSituationExclusions = React.lazy(() => import('./component'));
